import {UserRepository} from "@api/repositories/UserRepository";
import Axios from "axios";
import { prepareProfileFilter } from '@api/helpers/profileSearch';
import {PROFILE_FIELDS_BASIC} from "@api/models/UserProfile";
import { getIgnoringQueryObject } from "@service/helpers/exclusionGroupHelper";

let cancelToken: any = null;

const userSearch = async (
        take: number,
        skip: number,
        userRepository: UserRepository,
        searchStr: string,
        excludedUserIds: number[],
        groupFilter: {},
        ignoredUserGroupIds: string[] | undefined = undefined,
        eventId = '',
        role: string | string[] = '') => {
    if (cancelToken) {
        cancelToken.cancel();
    }

    const where  = prepareProfileFilter({
        searchStr: searchStr,
        additionalFields: [],
        excludingUsers: excludedUserIds,
        groupFilter: groupFilter,
        eventId: eventId
    });

    if (ignoredUserGroupIds) {
        where.$and.push(getIgnoringQueryObject(ignoredUserGroupIds))
    }

    if (role || role.length > 0) {
        where.$and.push(
            {
                userId: {
                    $inQuery: {
                        schema: "EventMemberships",
                        where: {
                            eventSchemaId: process.env.VUE_APP_EVENTS_SCHEMA,
                            eventObjectId: eventId,
                            type: {
                                $in: Array.isArray(role) ? role : [role]
                            },
                            status: {
                                $in: ['confirmed', 'mandatory']
                            },
                            isDeleted: false
                        },
                        "selectField": "userId"
                    }
                }
            }
        )
    }

    let query = {
        take,
        skip,
        include: PROFILE_FIELDS_BASIC,
        order: {
            lastName: 'asc',
            firstName: 'asc'
        }
    };

    if (Object.keys(where).length) {
        query = Object.assign(query, {where: where});
    }

    cancelToken = Axios.CancelToken.source();

    return await userRepository.profilesWithCount(query, {
        cancelToken: cancelToken.token
    });
}

export { userSearch }
